export const VITE_AGENT_URL = import.meta.env.VITE_AGENT_URL || '';
export const AGENT_PORTAL_DASH_URL = import.meta.env.DEV
    ? '/sapps/ratequote/producer/startRateQuoteProcess.do'
    : `${VITE_AGENT_URL}/sapps/ratequote/producer/startRateQuoteProcess.do`;
export const PRODUCER_SESSION_DETAILS_URL = import.meta.env.DEV
    ? '/ProducerRestServices/getSessionDetails'
    : `${VITE_AGENT_URL}/ProducerRestServices/getSessionDetails`;

export const EMPTY_PRODUCER_SESSION = {
    firstName: '',
    lastName: '',
    email: '',
    phone: '',
    phoneNumber: '',
    workPhoneNumber: '',
    producerNumber: '',
    pNumber: '',
    userID: '',
};
